import React from 'react';

export interface IButtonCommonProps {
    text: string;
    type?: 'button' | 'submit';
    size?: 'small' | 'medium' | 'large';
    buttonClass?: 'primary' | 'warning' | 'danger';
    buttonStyle?: 'default' | 'link';
    style?: React.CSSProperties;
    className?: string;
    disabled?: boolean;
}

interface IButtonBaseProps extends IButtonCommonProps {
    onClick?: () => void;
}

const ButtonBase: React.FC<IButtonBaseProps> = (props) => {
    let className = `dlc-form-button-${props.buttonStyle} ${props.buttonClass} ${props.size}`;

    if (props.className) {
        className += ' props.className';
    }

    return (
        <button className={className} type={props.type} style={props.style} onClick={props.onClick} disabled={props.disabled}>
            {props.text}
        </button>
    );
};

ButtonBase.defaultProps = {
    type: 'button',
    size: 'medium',
    buttonClass: 'primary',
    buttonStyle: 'default',
};

ButtonBase.displayName = 'ButtonBase';

export default ButtonBase;



// WEBPACK FOOTER //
// ./src/components/controls/forms/base/ButtonBase.tsx